import { render, staticRenderFns } from "./KusBaseDateRangeField.vue?vue&type=template&id=0a24a610"
import script from "./KusBaseDateRangeField.vue?vue&type=script&lang=js"
export * from "./KusBaseDateRangeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports